import React from 'react';
import classnames from 'classnames';

import Footer from '../Footer';

import styles from './PrivacyPolicy.module.css';

const PrivacyPolicy = () => {
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <h1 className={styles.headline}>Privacy Policy</h1>
          <p className={classnames([styles.paragraph, styles.paragraph_lead])}>
            Privacy Policy <br />
            Effective date: August 8, 2018
          </p>
          <p className={styles.paragraph}>
            Sure, Inc. (“Sure”) takes your privacy and the security of your
            information very seriously, and we encourage you to read this notice
            carefully to understand how we collect and handle your information.
          </p>
          <p className={styles.paragraph}>
            Our privacy policy describes the type of information our website and
            our mobile app collect from you, and the steps we have taken to
            protect that information. Sure collects personal information, like
            your name, address, and email address, when you use our website and
            our app. We provide this information to our Insurance Partners when
            you purchase insurance coverage, and we also use it to enhance the
            quality of services. Here are some links to help you navigate our
            privacy policy:
          </p>
          <ul className={styles.list}>
            <li>What Information Does Sure Collect From Me?</li>
            <li>What Does Sure Do With The Information It Collects?</li>
            <li>Does Sure Use Cookies of Beacons?</li>
            <li>Does Sure Collect Payment Card Information?</li>
            <li>Does Sure Collect Location Information?</li>
            <li>Does Sure Track My Activity Across Other Websites?</li>
            <li>Can I Choose To Stop Receiving Marketing Messages?</li>
            <li>Can Children Use Sure Website or App?</li>
            <li>What If I Live Outside of the United States?</li>
            <li>How Does Sure Protect My Information?</li>
            <li>Will Sure Change This Privacy Policy?</li>
            <li>How Do I Contact Sure?</li>
          </ul>
          <p className={styles.paragraph}>
            We also want you to know that we partner with third-party insurance
            provides to provide insurance products. And you should check out
            their privacy policies in addition to ours.
          </p>
          <p className={styles.paragraph}>
            If you have additional privacy or information security questions
            after reading this Privacy Policy, please contact us at{' '}
            <a className={styles.link} href="mailto:info@sureapp.com">
              info@sureapp.com
            </a>{' '}
            or via our website at{' '}
            <a className={styles.link} href="https://www.sureapp.com">
              https://sureapp.com
            </a>
            .
          </p>
          <p className={styles.paragraph}>
            Sure collects certain information from you when you share that
            information with us and when you use our app, our website and
            related services. Sure is responsible for how that information is
            stored, processed and disclosed. This notice explains how Sure
            stores, processes and discloses your information.
          </p>
          <ul className={styles.list}>
            <li>
              Personal Information: Sure may collect certain information from
              you, such as your name, address, email address, telephone number,
              zip code, location information, and other contact information. We
              call this information “Personal Information.” We don’t share
              Personal Information with third parties except as specified in
              this privacy policy.
            </li>
            <li>
              App Information: Sure collects information about you from our app.
              This includes your preferred language, your phone number, the make
              and model of your phone, your mobile operating system, the type of
              browser you are using, your IP address or other unique identifier,
              and your geolocation. We call this information “App Information.”
            </li>
            <li>
              Analytics Information: Sure has partnered with Google Analytics
              and Mixpanel to collect information about how our website is used
              and with Segment to collect information from your mobile device.
              Both Google Analytics and Segment collect information about how
              many times you visit our website and app, what you visit when you
              explore our website and app, and what other sites you visit before
              and after visiting our website. You can learn more about Google
              Analytics by reviewing its terms of use at:
              <a
                className={styles.link}
                href="https://www.google.com/analytics/terms/us.html"
              >
                https://www.google.com/analytics/terms/us.html
              </a>
              . And you can learn more about Mixpanel by reviewing its terms of
              use at:
              <a className={styles.link} href="https://segment.com/terms/">
                https://segment.com/terms/
              </a>
              .
            </li>
            <li>
              Site Visit Information: Sure also collects certain types of
              non-personal information whenever you visit our website. This
              information helps Sure operate our app and our website, and
              provide other services, including advertisements, ad serving, and
              technical support. By “Site Visit Information” we mean information
              that does not identify you personally, such as IP address, device
              information, and browser information.
            </li>
          </ul>
          <h2 className={styles.subheadline}>
            What does SURE do with the information it collects?
          </h2>
          <p className={styles.paragraph}>
            Sure collects information from you to provide insurance coverage, to
            alert you to exciting opportunities, and to improve the quality and
            functioning of our mobile app and our website. Sure does not sell or
            lease the information you share with third-parties, but we do share
            it with select Partners, including insurance companies. You should
            read this section carefully to learn more about what we do with the
            information you share with us.
          </p>
          <ul className={styles.list}>
            <li>
              Sure’s use of your Personal, App, Analytics, and Site Visit
              Information: Sure uses Information you share with us to provide
              insurance services, to enhance the quality of our app and our
              website, and to market additional products and services to you.
            </li>
            <li>
              Sure may share Personal, App, Analytics, and Site Visit
              Information with Service Providers: Sure may share your Personal,
              App, Analytics, and Site Visit Information with certain trusted
              third-parties to perform functions and provide services to us,
              including insurance services, order processing, customer
              relationship management, database storage and management,
              advertising, and direct marketing campaigns. Sure calls these
              third parties our “Partners.”
            </li>
            <li>
              Sure’s Insurance Partners and Your Beneficiaries: Sure relies on
              its Insurance Partners to provide high-quality insurance products,
              when you purchase an insurance product and for the servicing of
              that product, we share your name, address, email address, and
              telephone number with our Insurance Partners. We also share
              information about any beneficiaries you designate, and your flight
              information. Although we carefully select our Insurance Partners,
              and believe each one shares our commitment to your privacy, we
              have no control over how they use, or disclose your information.
              All Insurers are required to manage your information in accordance
              with the applicable law and regulation. We do not provide App
              Information, Analytics Information or Site Visit Information to
              our Insurance Partners
            </li>
            <li>
              Legal and law enforcement requests: Sure may also disclose, at its
              sole discretion, your Personal or Site Visit Information as
              required by law, or to comply with a legally binding request—like
              a subpoena, warrant, or similar legally enforceable request for
              information.
            </li>
          </ul>
          <h2 className={styles.subheadline}>
            Does SURE use cookies or beacons?
          </h2>
          <p className={styles.paragraph}>
            “Cookies” are electronic files many websites place on a visitor’s
            computer to store information that makes each visit to a respective
            site more efficient. Sure uses both “session” cookies on its website
            and uses both “session” and “persistent” cookies on its app. A
            session cookie stores information about you only while you are
            visiting our site, and is then deleted when you leave our site.
            Persistent cookies store information about you, your preferences,
            and information about other websites you visit, and it remains on
            your computer or device after you leave our website. To remove
            cookies, you may configure your browser or mobile device to clear
            all cookies, or configure them to reject cookies whenever you visit
            a new website. Please consult your browser or mobile device’s user
            guide for specific instructions on removing cookies.
          </p>
          <p className={styles.paragraph}>
            As we discussed above, Sure partners with Google Analytics, Segment
            and Mixpanel to improve the quality of our website, and to give you
            access to more relevant advertising. Google Analytics and Mixpanel
            may install persistent cookies on your computer or mobile device to
            perform these services when you first visit our website. This allows
            these companies to track your activity on Sure’s website, on your
            mobile device, and on other sites you visit. You should be aware
            that Sure cannot control Google Analytics or Mixpanel’s use of
            cookies, and their use is not covered by our Privacy Policy.
          </p>
          <h2 className={styles.subheadline}>
            Does SURE collect payment card information?
          </h2>
          <p className={styles.paragraph}>
            Sure does not collect credit, debit, or other financial data on its
            app or its website, and we never have access to that information.
            Sure partners with Stripe to collect and process your credit or
            debit card payments. You can check out Stripe’s terms of use here:
            <a className={styles.link} href="https://www.stripe.com/terms">
              https://www.stripe.com/terms
            </a>
            . No Insurance Partners have access to credit, debit or other
            financial data from Sure or Stripe.
          </p>
          <p className={styles.paragraph}>
            Sure uses Plaid Technologies, Inc. (“Plaid”) to gather End User’s
            data from financial institutions. By using our service, you grant
            Sure and Plaid the right, power, and authority to act on your behalf
            to access and transmit your personal and financial information from
            the relevant financial institution. You agree to your personal and
            financial information being transferred, stored, and processed by
            Plaid in accordance with the Plaid Privacy Policy.
          </p>
          <h2 className={styles.subheadline}>
            Does SURE collect local information?
          </h2>
          <p className={styles.paragraph}>
            Sure collects information about your location when you use our app
            to purchase insurance. Sure uses location information for fraud
            prevention, and to remind you to consider purchasing insurance
            before travelling. No Insurance Partner has access to location
            information.
          </p>
          <p className={styles.paragraph}>
            Sure’s app will not work unless you have enabled location services
            on your device, and have given the app permission to access your
            location. Except as otherwise provided in this privacy policy, Sure
            will not share information about your location with third parties,
            including our Insurance Partners.
          </p>
          <h2 className={styles.subheadline}>
            Does SURE track my activity across other websites?
          </h2>
          <p className={styles.paragraph}>
            Sure may track your activity across multiple websites. When you
            visit our website, we automatically collect the name of the website
            you visited from (called the “referring page”) and the name of the
            website you chose to visit immediately after ours (called the “exit
            page”), and information about other websites you have recently
            visited. This information is used to improve our website, but we
            cannot identify you from any information we receive from cookies
            (see “Does Sure Use Cookies or Beacons?”). Sure does not honor the
            “Do Not Track” settings available on most browsers. When Sure’s
            website detects the Do Not Track signal from your browser, it will
            still collect referring and exit page information and other
            information when you visit our website. Sure does not disclose this
            information to any Insurance Partner.
          </p>
          <h2 className={styles.subheadline}>
            Can I choose to stop receiving marketing messages from SURE?
          </h2>
          <p className={styles.paragraph}>
            Sure may send you newsletters and other messages, including
            marketing emails, about exciting developments with our business, and
            to alert you to relevant advertisements and other opportunities. We
            will only send you communications if you give us express permission
            to do so by completing a form on our app or our website. You can
            always choose to stop receiving newsletters or other communications
            from us by clicking the “unsubscribe” link at the bottom of a Sure
            marketing message.
          </p>
          <h2 className={styles.subheadline}>
            Can children use SURE’s website or app?
          </h2>
          <p className={styles.paragraph}>
            Our website and our app are not directed at children under 18, and
            we do not knowingly collect personal or other information from
            children under 18. Simply put, Sure does not permit children users
            under the age of 18 to use our website to create accounts, or to
            perform any other type of activity. If you are the parent of a child
            under the age of 13, and you believe he or she has shared
            information with Sure, please contact us at{' '}
            <a className={styles.link} href="mailto:privacy@sureapp.com">
              privacy@sureapp.com
            </a>{' '}
            so we can remove their information from our systems.
          </p>
          <h2 className={styles.subheadline}>
            What if I live outside the Unites States?
          </h2>
          <p className={styles.paragraph}>
            Sure is based in the United States, and our website and our app are
            hosted there. If you are visiting our website from another country,
            the laws governing our website’s collection and use of personal
            information may be different from the laws of your country. If you
            decide to visit our website, use our app, or share your personal
            information with Sure, you are agreeing to be governed by the laws
            of the United States, and you are expressly consenting to the
            transfer of your data to the United States. Our Insurance Partners
            may receive your information from the United States, but they will
            not send your information or information on the insurance products
            you purchase to the United States.
          </p>
          <h2 className={styles.subheadline}>
            What if I follow a link to a third-party website?
          </h2>
          <p className={styles.paragraph}>
            Sure’s website and our app may contain links to third-party
            websites. Those websites are governed by their own privacy and data
            use practices and policies. Sure does not have control over the
            privacy practices of the advertisers or other third-parties
            operating these websites, and we have no control over how these
            third parties collect or use the information you chose to share with
            them.
          </p>
          <h2 className={styles.subheadline}>
            How does SURE protect my information?
          </h2>
          <p className={styles.paragraph}>
            Sure takes the security of your personal information very seriously.
            Sure uses reasonable administrative, physical, and technical
            safeguards to secure the personal information you share with us.
            Despite these safeguards and our additional efforts to secure your
            information, Sure cannot promise or guarantee that hackers,
            cybercriminals, or other unauthorized third-parties will not be able
            to defeat our security, and improperly collect, access, steal, or
            modify your personal information.
          </p>
          <h2 className={styles.subheadline}>
            Will SURE change this privacy policy?
          </h2>
          <p className={styles.paragraph}>
            Sure may update our privacy policy to reflect changes to our website
            and our information practices. If we make any material changes, we
            will notify you by posting a notice on our website with a link to
            our revised policy. We encourage you to periodically visit this page
            for the latest information on our privacy practices.
          </p>
          <h2 className={styles.subheadline}>How do I contact SURE?</h2>
          <p className={styles.paragraph}>
            For questions about this privacy policy or about Sure’s privacy and
            information security practices generally, you can contact Sure at{' '}
            <a className={styles.link} href="mailto:info@sureapp.com">
              info@sureapp.com
            </a>
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
